import { WorldIcon } from '@/assets/world-icon';

const styles = {
  container: {
    display: 'grid',
    placeItems: 'center',
    gridAutoFlow: 'column',
    gap: 4,
    fontSize: 12,
  },
};
export function LanguageButton({ language }: { language: string }) {
  return (
    <div style={styles.container} id="language-toggle">
      <WorldIcon size={14} />
      <span>{language === 'es' ? 'ES' : 'EN'}</span>
    </div>
  );
}
